"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefundsController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const refunds_service_1 = require("./refunds.service");
const refund_entity_1 = require("./refund.entity");
const jwt_auth_guard_1 = require("../../common/guards/jwt-auth.guard");
const permissions_guard_1 = require("../../common/guards/permissions.guard");
const permissions_decorator_1 = require("../../common/decorators/permissions.decorator");
const current_user_decorator_1 = require("../../common/decorators/current-user.decorator");
const user_entity_1 = require("../users/user.entity");
const permissions_1 = require("../authorization/permissions");
let RefundsController = class RefundsController {
    constructor(refundsService) {
        this.refundsService = refundsService;
    }
    findAll(customerId, status) {
        return this.refundsService.findAll(customerId ? parseInt(customerId, 10) : undefined, status);
    }
    findOne(id) {
        return this.refundsService.findById(id);
    }
    create(body, user) {
        return this.refundsService.create({ ...body, createdById: user.id });
    }
    teamLeadReview(id, body, user) {
        return this.refundsService.teamLeadReview(id, body.satisfied, body.remarks, user.id);
    }
    managementReview(id, body, user) {
        return this.refundsService.managementReview(id, body.satisfied, body.remarks, user.id, body.approvedAmount, body.refundMethod);
    }
    markRefunded(id, body, user) {
        return this.refundsService.markRefunded(id, body.approvedAmount, body.refundMethod, user.id);
    }
};
exports.RefundsController = RefundsController;
tslib_1.__decorate([
    (0, common_1.Get)(),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.REFUNDS_READ),
    tslib_1.__param(0, (0, common_1.Query)('customerId')),
    tslib_1.__param(1, (0, common_1.Query)('status')),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, typeof (_b = typeof refund_entity_1.RefundStatus !== "undefined" && refund_entity_1.RefundStatus) === "function" ? _b : Object]),
    tslib_1.__metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
], RefundsController.prototype, "findAll", null);
tslib_1.__decorate([
    (0, common_1.Get)(':id'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.REFUNDS_READ),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number]),
    tslib_1.__metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
], RefundsController.prototype, "findOne", null);
tslib_1.__decorate([
    (0, common_1.Post)(),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.REFUNDS_CREATE),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__param(1, (0, current_user_decorator_1.CurrentUser)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, typeof (_e = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _e : Object]),
    tslib_1.__metadata("design:returntype", typeof (_f = typeof Promise !== "undefined" && Promise) === "function" ? _f : Object)
], RefundsController.prototype, "create", null);
tslib_1.__decorate([
    (0, common_1.Patch)(':id/team-lead-review'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.REFUNDS_TEAM_LEAD_REVIEW),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, current_user_decorator_1.CurrentUser)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object, typeof (_g = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _g : Object]),
    tslib_1.__metadata("design:returntype", typeof (_h = typeof Promise !== "undefined" && Promise) === "function" ? _h : Object)
], RefundsController.prototype, "teamLeadReview", null);
tslib_1.__decorate([
    (0, common_1.Patch)(':id/management-review'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.REFUNDS_MANAGEMENT_REVIEW),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, current_user_decorator_1.CurrentUser)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object, typeof (_j = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _j : Object]),
    tslib_1.__metadata("design:returntype", typeof (_k = typeof Promise !== "undefined" && Promise) === "function" ? _k : Object)
], RefundsController.prototype, "managementReview", null);
tslib_1.__decorate([
    (0, common_1.Patch)(':id/mark-refunded'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.REFUNDS_MARK_REFUNDED),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, current_user_decorator_1.CurrentUser)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object, typeof (_l = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _l : Object]),
    tslib_1.__metadata("design:returntype", typeof (_m = typeof Promise !== "undefined" && Promise) === "function" ? _m : Object)
], RefundsController.prototype, "markRefunded", null);
exports.RefundsController = RefundsController = tslib_1.__decorate([
    (0, common_1.UseGuards)(jwt_auth_guard_1.JwtAuthGuard, permissions_guard_1.PermissionsGuard),
    (0, common_1.Controller)('refunds'),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof refunds_service_1.RefundsService !== "undefined" && refunds_service_1.RefundsService) === "function" ? _a : Object])
], RefundsController);
